export default __webpack_public_path__ + "static/media/socialTwitter.712ac877.svg";